export default __webpack_public_path__ + "static/media/bg-sm@1x.08dc83a7.webp";